<template lang='pug'>
span
  BotPageTitle
  h3(
    :style='{ fontSize: $vuetify.breakpoint.xsOnly ? "20px" : "" }'
    style='margin-top: 0; margin-bottom: 20px; padding: 0 15px')
  template(v-if='generalConfig')
    .md-layout
      v-row(no-gutters)
        v-col(cols='auto' style='margin: 12px')
          v-chip-group#chip-group(
            v-model='selectedProfile'
            mandatory
            show-arrows)
            v-chip(
              v-for='(profile, i) in generalConfig.webclientChannels',
              :key='i'
              @click='chipChange(i)'
              filter
              style='background-color: #ff9800; border-color: #ff9800; color: white !important; transition: 0.5s')
              | {{ profile.name }}
              v-icon.profile-edit-icon(@click='triggerEditing(i)') mdi-square-edit-outline
    CanalInstagramSinglePage(
      :canalWebData='generalConfig.webclientChannels[selectedProfile].config',
      :canalWebId='generalConfig.webclientChannels[selectedProfile].id',
      :canalIgChannels='generalConfig.igChannels[selectedProfile]')
    .md-layout
      v-row(no-gutters style='justify-content: center')
        v-col(cols='auto' style='margin: 12px')
        v-col(cols='auto' style='margin: 12px')
          md-button.md-success(
            @click='saveData(selectedProfile, "save"); modified = false'
            style='display: block; margin-left: auto; margin-right: auto')
            span(style='color: black') {{ $t("commonWords.save") }}
    v-dialog(
      v-model='saveDataDialog'
      max-width='500px'
      @click:outside.stop='saveActionDialog("cancel")')
      v-card
        v-card-title.headline(v-if='oldSelectedProfile !== null') {{ $t("webChannel.saveChanges") }} "{{ generalConfig.webclientChannels[oldSelectedProfile].name }}?"
        v-card-actions
          md-button.md-simple(
            @click='saveActionDialog("cancel")'
            style='margin: 0px')
            span {{ $t("commonWords.cancel") }}
          v-spacer
          md-button.md-danger(
            @click='saveActionDialog("dont-save")'
            style='margin: 12px')
            span {{ $t("commonWords.dontSave") }}
          md-button.md-success(
            @click='saveActionDialog("save")'
            style='margin: 12px')
            span {{ $t("commonWords.save") }}
  v-fade-transition
    v-overlay(:value='loading')
      v-progress-circular(
        style='display: inline-block; width: 100%'
        indeterminate
        size='64')
      .h2.font-weight-thin(
        style='display: inline-block; width: 100%; height: 100%')
        | {{$t('canalInstagram.loadingSettings')}}
</template>
<script>
import BotPageTitle from '@/components/BotPageTitle.vue'
import CanalInstagramSinglePage from '@/components/Settings/CanalInstagram/CanalInstagramSinglePage.vue'
import Swal from 'sweetalert2'
import { mapFields } from 'vuex-map-fields'
export default {
  components: { BotPageTitle, CanalInstagramSinglePage },
  watch: {
    selectedProfile (nV, oV) {
      this.oldSelectedProfile = oV
    }
  },
  computed: {
    ...mapFields('webChannel', ['modified']),
    ...mapFields('selectedAssistant', ['assistantId']),
    idleWarningMessage () {
      return (
        this.generalConfig.webclientChannels[this.selectedProfile].config
          .isExpirationWaringActive === true &&
        this.generalConfig.webclientChannels[this.selectedProfile].config
          .idleWarningMessage.length === 0
      )
    },
    idleTerminationMessage () {
      return (
        this.generalConfig.webclientChannels[this.selectedProfile].config
          .isTerminationActive === true &&
        this.generalConfig.webclientChannels[this.selectedProfile].config
          .idleTerminationMessage.length === 0
      )
    },
    missingIdleTerminationTime () {
      return (
        this.generalConfig.webclientChannels[this.selectedProfile].config
          .isTerminationActive === true &&
        this.generalConfig.webclientChannels[this.selectedProfile].config
          .customerIdleTerminationSeconds <= 0
      )
    },
    missingIdleWarningTime () {
      return (
        this.generalConfig.webclientChannels[this.selectedProfile].config
          .isExpirationWaringActive === true &&
        this.generalConfig.webclientChannels[this.selectedProfile].config
          .customerIdleWarningSeconds <= 0
      )
    },
    invalidIdleTerminationAndWarningTime () {
      return (
        this.generalConfig.webclientChannels[this.selectedProfile].config
          .isTerminationActive &&
        this.generalConfig.webclientChannels[this.selectedProfile].config
          .isExpirationWaringActive &&
        parseInt(
          this.generalConfig.webclientChannels[this.selectedProfile].config
            .customerIdleWarningSeconds
        ) +
          10 >
          parseInt(
            this.generalConfig.webclientChannels[this.selectedProfile].config
              .customerIdleTerminationSeconds
          )
      )
    },
    idleTerminationTime () {
      return (
        this.missingIdleTerminationTime ||
        this.invalidIdleTerminationAndWarningTime
      )
    },
    idleWarningTime () {
      return (
        this.missingIdleWarningTime || this.invalidIdleTerminationAndWarningTime
      )
    }
  },
  data () {
    return {
      loading: true,
      selectedProfile: 0,
      oldSelectedProfile: null,
      saveDataDialog: false,
      canalWebBackUp: {},
      chipGpKey: 0,
      generalConfig: null
    }
  },
  methods: {
    async triggerEditing (index) {
      this.$nextTick(async () => {
        if (!this.modified) {
          const { value: text } = await Swal.fire({
            title: this.$t('canalInstagram.changeTheNameOfThisProfile'),
            input: this.$t('canalInstagram.text'),
            inputValue: this.generalConfig.webclientChannels[index].name,
            inputPlaceholder: this.$t('canalInstagram.enterProfileName'),
            inputValidator: (value) => {
              if (!value) {
                return this.$t('canalInstagram.fillInTheFieldAbove')
              }
            }
          })
          if (text) {
            this.generalConfig.webclientChannels[index].name = text
            await this.saveData(this.selectedProfile, 'save')
          }
        }
      })
    },
    chipChange () {
      if (this.modified) {
        this.saveDataDialog = true
      } else {
        setTimeout(() => {
          this.modified = false
          this.updateBackup()
        }, 5)
      }
    },
    async saveActionDialog (type) {
      if (type === 'cancel') {
        let aux = this.selectedProfile
        this.selectedProfile = this.oldSelectedProfile
        this.oldSelectedProfile = aux
      } else if (type === 'dont-save') {
        Swal.fire({
          icon: 'error',
          title: this.$t('canalInstagram.changesNotSaved')
        })
        this.generalConfig.webclientChannels[this.oldSelectedProfile] =
          this.canalWebBackUp
        this.updateBackup()
        this.modified = false
      } else if (type === 'save') {
        await this.saveData(this.selectedProfile, 'save')
        this.modified = false
        Swal.fire({
          icon: 'success',
          title: this.$t('canalInstagram.changesHaveBeenSaved')
        })
        this.updateBackup()
      }
      this.saveDataDialog = false
    },
    updateBackup () {
      this.canalWebBackUp = JSON.parse(
        JSON.stringify(
          this.generalConfig.webclientChannels[this.selectedProfile]
        )
      )
    },
    requiredFieldsError () {
      Swal.fire({
        icon: 'error',
        title: this.$t('canalInstagram.fillInTheMandatoryFields')
      })
    },
    async saveData (index, type) {
      const locale = this._i18n._vm.fallbackLocale
      const messages = this._i18n._vm.messages[locale]
      let save = true
      // id dos itens do array removidos/alterados
      if (type === 'save') {
        const instagramValidation = this.generalConfig?.igChannels[0]

        const requiredInstagramFields = [
          {
            property: 'acessToken',
            value: messages.igChannel.connectionSettings.subitems.accessToken
          },
          {
            property: 'appId',
            value: messages.igChannel.connectionSettings.subitems.appId
          },
          {
            property: 'appSecret',
            value: messages.igChannel.connectionSettings.subitems.appSecret
          },
          {
            property: 'pageId',
            value: messages.igChannel.connectionSettings.subitems.pageId
          },
          {
            property: 'secretKey',
            value: messages.igChannel.connectionSettings.subitems.secretKey
          }
        ]

        let errors = []
        for (let index = 0; index < requiredInstagramFields.length; index++) {
          const { property, value } = requiredInstagramFields[index]
          if (
            !instagramValidation.config[property] &&
              instagramValidation.config[property] === ''
          ) {
            errors.push(value)
          }
        }
        if (errors.length > 0) {
          Swal.fire({
            icon: 'error',
            title: `${messages.commonPhrases.requiredFields}${errors.join(', ')}`
          })
          save = false
          return
        }
        const { hostname } = window.location
        const [env, tenant] = hostname.split('-')
        this.generalConfig.igChannels[0].id = this.generalConfig.igChannels[0].config.pageId
        this.generalConfig.igChannels[0].config.channelId = this.generalConfig.igChannels[0].config.pageId
        this.generalConfig.igChannels[0].config.channel = 'instagram'
        this.generalConfig.igChannels[0].config.env = env
        this.generalConfig.igChannels[0].config.tenantName = tenant

        if (
          this.idleWarningMessage ||
          this.idleTerminationMessage ||
          this.idleTerminationTime ||
          this.idleWarningTime
        ) {
          this.requiredFieldsError()
          save = false
        } else {
          this.loading = true
          this.deletedConfigID = null
          this.savedConfigID = this.generalConfig.webclientChannels[index].id
        }
      } else if (type === 'delete') {
        this.loading = true
        this.savedConfigID = null
        this.deletedConfigID = this.generalConfig.webclientChannels[index].id
        this.generalConfig.webclientChannels.splice(index, 1)
        this.generalConfig.webclientChannels = [
          ...this.generalConfig.webclientChannels
        ]
      }
      var domains = this.generalConfig?.webclientChannels[0]?.config?.domains

      if (
        typeof this.generalConfig?.webclientChannels[0]?.config?.domains ===
        'string'
      ) {
        domains = domains.split('\n')
      }
      this.generalConfig.webclientChannels[0].config.domains = domains

      if (save) {
        await this.$axios
          .put(`/assistant-configs/${this.assistantId}`, this.generalConfig)
          .then(() => {
            this.loading = false
            this.$vuetify.goTo(0)
          })
          .catch((error) => {
            Swal.fire({
              icon: 'error',
              title: this.$t('canalInstagram.error'),
              html: `${this.$t('canalInstagram.unableToSaveWizardSettings')} <br> ${error}`
            })
          })
      }
    },
    async duplicateData () {
      const { value: text } = await Swal.fire({
        title: this.$t('canalInstagram.duplicateThisProfile'),
        text: this.$t('canalInstagram.toDuplicateThisProfile'),
        input: this.$t('canalInstagram.text'),
        inputValue:
          this.generalConfig.webclientChannels[this.selectedProfile].name +
          this.$t('canalInstagram.copy'),
        inputPlaceholder: this.$t('canalInstagram.enterNameNewProfile'),
        showCancelButton: true,
        confirmButtonText: this.$t('canalInstagram.create'),
        cancelButtonText: this.$t('canalInstagram.cancel'),
        confirmButtonColor: '#4caf50',
        inputValidator: (value) => {
          if (!value) {
            return this.$t('canalInstagram.fillInTheFieldAbove')
          }
        }
      })

      if (text) {
        const originalIndex = this.selectedProfile
        const copy = JSON.parse(
          JSON.stringify(this.generalConfig.webclientChannels[originalIndex])
        )
        copy.name = text
        this.generalConfig.webclientChannels.push(copy)
        const lastIndex = this.generalConfig.webclientChannels.length - 1
        await this.saveData(lastIndex, 'save')

        this.selectedProfile = lastIndex

        this.chipChange()
      }
    },
    async deleteData () {
      const that = this
      const { value: text } = await Swal.fire({
        title: this.$t('canalInstagram.wantDeleteThisProfile'),
        text: `${this.$t('canalInstagram.IfDeleteThisProfile')} "${
          that.generalConfig.webclientChannels[that.selectedProfile].name
        }" ${this.$t('canalInstagram.clickConfirm')}`,
        input: this.$t('canalInstagram.text'),
        inputPlaceholder: this.$t('canalInstagram.enterProfileNameToDelete'),
        showCancelButton: true,
        confirmButtonText: this.$t('canalInstagram.remove'),
        cancelButtonText: this.$t('canalInstagram.cancel'),
        confirmButtonColor: '#ff5252',
        inputValidator: (value) => {
          if (
            value !==
            that.generalConfig.webclientChannels[that.selectedProfile].name
          ) {
            return this.$t('canalInstagram.pleaseFillInTheField')
          }
        }
      })

      if (text) {
        const deleteIndex = this.selectedProfile
        this.selectedProfile = 0
        setTimeout(async () => {
          this.modified = false
          await this.saveData(deleteIndex, 'delete')
        }, 500)
        this.chipChange()
        this.$forceUpdate()
      }
    }
  },
  created () {
    if (typeof this.assistantId === typeof null) {
      Swal.fire({
        text: this.$t('canalInstagram.pleaseSelectCognitiveAssistant'),
        icon: 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK'
      })
      this.$router.push('/lista-assistentes')
    }
  },
  async mounted () {
    if (typeof this.assistantId !== typeof null) {
      this.$axios
        .get(`/assistant-configs/${this.assistantId}`)
        .then((response) => {
          this.generalConfig = response.data
          this.updateBackup()
          this.oldSelectedProfile = 0
        })
        .catch((error) => {
          Swal.fire({
            icon: 'error',
            title: this.$t('canalInstagram.error'),
            html: `${this.$t('canalInstagram.couldNotAccessWizardSettings')} <br> ${error}`
          })
        })
      this.loading = false
    }
  }
}
</script>

<style>
#chip-group .v-chip__content > .v-icon.v-icon--left {
  font-size: 12px !important;
}
.profile-edit-icon {
  transition: 0.5s;
  font-size: 0px !important;
  color: rgba(0, 0, 0, 0.54) !important;
}
#chip-group .v-chip:hover .profile-edit-icon {
  font-size: 18px !important;
  margin: 4px;
}
</style>
